import { useRef, useEffect } from 'react'
import { useInView } from 'framer-motion'
import { EventNames } from '../types/misc.types'
import { trackEvent } from '../utils/appBridge'
import { useMetaDataContext } from '../state-management/contexts/MetaDataContext'
import { MutualFundDetailSections } from '../types/mutual-fund-detail.types'

export const useMutualFundDetailScrollEvent = ({ sectionKey }: { sectionKey: `${MutualFundDetailSections}` }) => {
  const { data, isin } = useMetaDataContext()
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef)

  const sectionNames: { [x in `${MutualFundDetailSections}`]: string } = {
    [MutualFundDetailSections.HEADER_ACCORDIONS]: 'Returns',
    [MutualFundDetailSections.UNAVAILABLE_SECTIONS]: 'Unavailable sections banner', // not tracked right now
    [MutualFundDetailSections.POWER_PERFORMANCE]: 'Power_Performance',
    [MutualFundDetailSections.FUND_HOLDINGS]: 'Fund_Holdings',
    [MutualFundDetailSections.FUND_INFORMATION]: 'Fund_Information',
    [MutualFundDetailSections.FUND_OBJECTIVE]: 'Fund_Objectives',
    [MutualFundDetailSections.ELITE_STATS]: 'PowerUP_Elite'
  }

  const getOrder = () => {
    const modifiedSections = data?.sections?.filter((datum) => datum !== 'UNAVAILABLE_SECTIONS')
    return (modifiedSections?.findIndex((datum) => datum === sectionKey) ?? -1) + 1
  }

  useEffect(() => {
    if (isInView) {
      trackEvent({
        eventName: EventNames.VScroll,
        payload: {
          scrollSection: sectionNames?.[sectionKey],
          orderCount: `${getOrder()}`,
          screenType: 'MF_L2',
          fundName: isin
        }
      })
    }
  }, [isInView])

  return sectionRef
}
